<template>
  <transition name="fade">
    <div
      v-show="visible"
      :aria-hidden="visible ? 'false' : 'true'"
      class="modal"
    >
      <div
        ref="box"
        aria-labelledby="modal-title"
        aria-modal="true"
        class="modal__box"
        role="dialog"
        tabindex="-1"
      >

        <header class="modal__header">
          <h2
            id="modal-title"
            class="modal__title"
          >
            {{ title }}
          </h2>
        </header>

        <p class="modal__content">
          {{ content }}
        </p>

        <footer class="modal__footer">
          <c-button
            v-for="(button, index) in buttons"
            :key="index"
            @click="clickHandler(button.handler)"
          >
            {{ button.text }}
          </c-button>
        </footer>

      </div>
    </div>
  </transition>
</template>

<script>
import CButton from '@/components/CButton'

import focusTrap from 'focus-trap'
import scrolling from '@/functions/scrolling'

export default {
  name: 'SModal',

  components: {
    CButton
  },

  data () {
    return {
      focusTrap: null
    }
  },

  computed: {
    buttons () {
      return this.$store.state.modal.buttons
    },
    content () {
      return this.$store.state.modal.content
    },
    title () {
      return this.$store.state.modal.title
    },
    visible () {
      return this.$store.state.modal.visible
    }
  },

  watch: {
    visible () {
      this.$nextTick(this.handleVisibilityChange)
    }
  },

  mounted () {
    this.focusTrap = focusTrap(this.$el, {
      escapeDeactivates: false,
      initialFocus: this.$refs.box
    })

    this.handleVisibilityChange()
  },

  methods: {
    clickHandler (handler) {
      if (handler) {
        handler()
      }

      this.$store.commit('modal/close')
    },
    handleVisibilityChange () {
      if (this.visible) {
        scrolling.disable()
        this.focusTrap.activate()
      } else {
        scrolling.enable()
        this.focusTrap.deactivate()
      }
    }
  }
}
</script>

<style scoped>
.modal {
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: var(--z-index-modal);

  background: rgba(0, 0, 0, 0.5);
}

.modal__box {
  width: 360px;
  max-width: 100%;

  line-height: 1.4;

  background: #fff;
  outline: 0;
}

.modal__header {
  margin: 0 0 15px;
  padding: 10px 20px;

  color: #fff;

  background: var(--color-brand);
}

.modal__title {
  margin: 0;

  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.modal__content {
  margin: 0 20px;
}

.modal__footer {
  margin: 15px 20px;
  text-align: center;
}
</style>
